import { Address } from './address';

class AddressQueryBuilder {
  text: string = '';

  with(data?: string) {
    if (!data) return this;
    if (this.text) this.text += ', ';
    this.text += data;
    return this;
  }

  build() {
    return this.text;
  }
}

export namespace AddressUtil {
  export function addressToSearchQuery(address?: Address) {
    if (!address) return '';

    const builder = new AddressQueryBuilder();

    return builder
      .with(address.addressLine1)
      .with(address.addressLine2)
      .with(`${address.postalCode} ${address.city}`.trim())
      .with(address.region)
      .with(address.countryCode)
      .build();
  }
}
